import React, { useEffect, useState } from "react";

export const WINDOWS = [
  { round: "Round 1", end: new Date("2026-11-04T23:59:59-08:00"), label: "Nov 4, 2026 · 11:59 PM PT", short: "Nov 4", note: "Order by Nov 4 for delivery before Christmas" },
  { round: "Round 2", end: new Date("2026-12-04T23:59:59-08:00"), label: "Dec 4, 2026 · 11:59 PM PT", short: "Dec 4", note: "Orders placed now will most likely arrive after Christmas" },
];

export const currentWindow = (now = Date.now()) => WINDOWS.find((w) => w.end.getTime() > now) || null;

const pad = (n) => String(n).padStart(2, "0");

export function useCountdown() {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  const w = currentWindow(now);
  const ms = w ? w.end.getTime() - now : 0;
  const s = Math.floor(ms / 1000);
  return { w, closed: !w, d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
}

export const CountdownBar = () => {
  const c = useCountdown();
  return (
    <div data-testid="countdown-bar" className="bg-yellow-400 text-black text-center font-mono text-[11px] sm:text-xs font-bold uppercase tracking-widest py-1.5 px-3">
      {c.closed ? (
        <span data-testid="countdown-closed">Order window closed</span>
      ) : (
        <span><span className="hidden md:inline" data-testid="countdown-bar-note">{c.w.note} · </span><span className="hidden sm:inline">Order window closes in </span><span className="sm:hidden">{c.w.short} cutoff </span><span data-testid="countdown-bar-time" className="tabular-nums">{c.d}d {pad(c.h)}h {pad(c.m)}m {pad(c.s)}s</span></span>
      )}
    </div>
  );
};

export const HeroCountdown = () => {
  const c = useCountdown();
  if (c.closed) {
    return <p data-testid="hero-countdown-closed" className="font-heading font-black uppercase text-3xl text-zinc-400">Order window closed</p>;
  }
  const units = [["Days", c.d], ["Hours", c.h], ["Mins", c.m], ["Secs", c.s]];
  return (
    <div data-testid="hero-countdown">
      <span className="text-zinc-400 block font-mono text-[10px] uppercase tracking-widest mb-2">{c.w.round} order window closes in</span>
      <div className="flex gap-2 sm:gap-3">
        {units.map(([label, v]) => (
          <div key={label} className="bg-black/60 backdrop-blur border border-yellow-400/30 rounded-md w-16 sm:w-20 py-2 text-center">
            <span data-testid={`hero-countdown-${label.toLowerCase()}`} className="block font-heading font-black text-3xl sm:text-4xl text-yellow-400 tabular-nums leading-none">{pad(v)}</span>
            <span className="block font-mono text-[9px] uppercase tracking-widest text-zinc-400 mt-1">{label}</span>
          </div>
        ))}
      </div>
      <span className="text-zinc-500 block font-mono text-[10px] uppercase tracking-widest mt-2">Closes {c.w.label}</span>
      <span data-testid="hero-countdown-note" className="text-yellow-400/90 block font-mono text-[10px] uppercase tracking-widest mt-1">{c.w.note}</span>
    </div>
  );
};

export const windowText = () => {
  const w = currentWindow();
  return w ? `${w.round} · Order window closes ${w.label} · ${w.note}` : "Order window closed";
};
